import * as Sentry from '@sentry/capacitor'

export function formatError(error: unknown): string {
  if (error instanceof Error) {
    return error.message
  }
  if (typeof error === 'string') {
    return error
  }
  if (typeof error === 'object' && error !== null) {
    return JSON.stringify(error)
  }
  return String(error)
}

export function sendError(error: unknown, context?: Record<string, string>): void {
  const message = formatError(error)
  Sentry.captureException(
    error instanceof Error ? error : new Error(message),
    context ? { tags: context } : undefined,
  )
  console.error(message, context)
}

export function sendInfo(message: string, context?: Record<string, string>): void {
  Sentry.captureMessage(message, {
    level: 'warning',
    tags: context,
  })
  console.warn(message, context)
}
